import { render, staticRenderFns } from "./collectOpportunitiesRecord.vue?vue&type=template&id=41eb098b&scoped=true"
import script from "./collectOpportunitiesRecord.vue?vue&type=script&lang=js"
export * from "./collectOpportunitiesRecord.vue?vue&type=script&lang=js"
import style0 from "./collectOpportunitiesRecord.vue?vue&type=style&index=0&id=41eb098b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eb098b",
  null
  
)

export default component.exports